import { kebabCase } from 'lodash-es';

import { generateClassName } from '@klv/shared/utils/functions';
import FadeInUp from '@klv/utils/fade-in-up';

import { getBackgroundImage, isGradient, getTextColor, getBackgroundColor, getPadding } from './functions';
import * as styles from './styles/wrapper.module.scss';

import type { IWrapperProps } from './types';


export const Wrapper = ({
  className = '',
  customPadding: { customPaddingBottom = 'md', customPaddingTop = 'md' } = {},
  inlinePadding = false,
  grid = false,
  contained = true,
  backgroundColor = 'transparent',
  customBackgroundColor,
  fadeIn = 0,
  children,
  style = {},
  ...rest
}: IWrapperProps) => {

  const Body = (fadeIn > 0) ? FadeInUp : 'div';
  const fadeInProps = (fadeIn > 0) ? { threshold: fadeIn } : {};
    
  // eliminates undefined values from the style object
  const styleObject: React.CSSProperties = JSON.parse(JSON.stringify({
    ...style,
    '--wrapper-background-image': getBackgroundImage(backgroundColor),
    '--wrapper-background-color': customBackgroundColor ? customBackgroundColor : `var(--color-core-${kebabCase(getBackgroundColor(backgroundColor === 'lightSand' ? 'cotton' : backgroundColor))})`,
    '--wrapper-color': `var(--color-core-${getTextColor(backgroundColor)})`,
  }));

  return (
    <div 
      {...rest}
      className={generateClassName([
        className,
        styles.wrapper,
        isGradient(backgroundColor) ? styles.gradient : '',
        `${getPadding(customPaddingTop)}PaddingTop`,
        `${getPadding(customPaddingBottom)}PaddingBottom`,
      ])}
      style={styleObject}
    >
      <Body className={generateClassName([
        grid ? styles.grid : '',
        inlinePadding ? 'inlinePadding' : '',
        contained ? 'contained' : '',
      ])} {...fadeInProps}>
        {children}
      </Body>
    </div>
  );
};
